import { extractPdf } from "./pdfExtraction";

const EXTRACTORS = [
  { code: "pdf", accepts: (file) => file?.type === "application/pdf" || file?.name?.toLowerCase().endsWith(".pdf"), extract: extractPdf },
];

export function supportedDocumentAccept() { return "application/pdf,.pdf"; }

export async function extractDocument(file, onProgress) {
  const extractor = EXTRACTORS.find((candidate) => candidate.accepts(file));
  if (!extractor) throw new Error(`SmartDoc does not support ${file?.type || file?.name || "this file format"}.`);
  return { format: extractor.code, ...(await extractor.extract(file, onProgress)) };
}
